/* ==========================================================================
   PuraMadera — Favoritos
   --------------------------------------------------------------------------
   Lista de deseos sin app y sin coste mensual. La tienda está en plan Basic
   y cada app suma suscripción, así que esto se resuelve en el tema.

   DÓNDE SE GUARDA, Y QUÉ IMPLICA
   En localStorage del navegador, bajo la clave pm_favoritos: un array de
   handles de producto. Eso significa que la lista vive en ESE teléfono o en
   ESE computador, no en la cuenta del cliente: si entra desde otro aparato,
   la lista no viaja. Es la diferencia honesta frente a una app de pago, y
   para abrir con trece referencias es un intercambio razonable. El día que
   haga falta que viaje con la cuenta, el salto natural es un metafield de
   cliente, que ya necesita sesión iniciada.

   CÓMO SE ENGANCHA
   No se edita ningún archivo de Craft. El botón se inyecta por JS sobre las
   tarjetas que ya existen (.card-wrapper) y sobre la ficha. Así el tema
   sigue pudiendo actualizarse sin arrastrar parches.
   ========================================================================== */

(function () {
  'use strict';

  var CLAVE = 'pm_favoritos';

  /* localStorage lanza en modo privado de algunos navegadores y cuando el
     usuario bloquea datos de sitio. Si falla, los favoritos simplemente no
     están; nada más de la página se rompe. */
  function leer() {
    try {
      var v = window.localStorage.getItem(CLAVE);
      var a = v ? JSON.parse(v) : [];
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }

  function guardar(lista) {
    try { window.localStorage.setItem(CLAVE, JSON.stringify(lista)); }
    catch (e) { /* sin almacenamiento: la sesión sigue, no persiste */ }
  }

  function tiene(handle) { return leer().indexOf(handle) !== -1; }

  function alternar(handle) {
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i === -1) lista.push(handle); else lista.splice(i, 1);
    guardar(lista);
    pintarContador();
    document.dispatchEvent(new CustomEvent('pm:favoritos', { detail: { lista: lista } }));
    return i === -1;
  }

  /* El handle sale de la propia URL del producto: /products/<handle> */
  function handleDeUrl(url) {
    if (!url) return null;
    var m = url.split('?')[0].match(/\/products\/([^/]+)/);
    return m ? m[1] : null;
  }

  var CORAZON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.3 4.6 13a4.6 4.6 0 0 1 6.5-6.5l.9.9.9-.9A4.6 4.6 0 0 1 19.4 13z"/></svg>';

  /* Antes los trece botones de la rejilla se llamaban igual ("Guardar en
     favoritos"), asi que con lector de pantalla no habia forma de saber cual
     era cual. Y el aria-label cambiaba con el estado a la vez que aria-pressed,
     que se lee contradictorio: "Quitar de favoritos, pulsado". El nombre pasa
     a ser fijo y con el titulo de la pieza; el estado lo dice aria-pressed. */
  function crearBoton(handle, etiqueta, nombrePieza) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pm-fav';
    b.dataset.pmFav = handle;
    b.setAttribute('aria-pressed', tiene(handle) ? 'true' : 'false');
    b.dataset.pmPieza = nombrePieza || '';
    b.innerHTML = CORAZON + '<span class="pm-fav__texto">' + esc(etiqueta) + '</span>';
    refrescarBoton(b);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var activo = alternar(handle);
      b.setAttribute('aria-pressed', activo ? 'true' : 'false');
      refrescarBoton(b);
    });
    return b;
  }

  /* El nombre accesible cambia con el estado: un lector de pantalla tiene que
     oír qué hace el botón AHORA, no cómo se llama la función. */
  function refrescarBoton(b) {
    var activo = b.getAttribute('aria-pressed') === 'true';
    var pieza = b.dataset.pmPieza;
    b.classList.toggle('pm-fav--activo', activo);
    b.setAttribute('aria-label', pieza ? 'Favorito: ' + pieza : 'Guardar en favoritos');
    var t = b.querySelector('.pm-fav__texto');
    if (t) t.textContent = activo ? 'Guardado' : 'Guardar';
  }

  /* ---------------------------------------------------------------------
     1. El corazón sobre cada tarjeta
     --------------------------------------------------------------------- */
  function montarEnTarjetas(raiz) {
    (raiz || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.pm-fav')) return;
      var enlace = card.querySelector('a[href*="/products/"]');
      var handle = handleDeUrl(enlace && enlace.getAttribute('href'));
      var marco = card.querySelector('.card__inner');
      if (!handle || !marco) return;
      var titulo = card.querySelector('.card__heading a, .card__heading');
      var b = crearBoton(handle, 'Guardar', titulo ? titulo.textContent.trim() : '');
      b.classList.add('pm-fav--tarjeta');
      marco.appendChild(b);
    });
  }

  /* ---------------------------------------------------------------------
     2. El botón de la ficha, bajo el de compra
     --------------------------------------------------------------------- */
  function montarEnFicha() {
    var zona = document.querySelector('.product-form__buttons');
    if (!zona || zona.querySelector('.pm-fav')) return;
    var handle = handleDeUrl(window.location.pathname);
    if (!handle) return;
    var h1 = document.querySelector('.product__title h1, .product__title .h1');
    var b = crearBoton(handle, 'Guardar', h1 ? h1.textContent.trim() : '');
    b.classList.add('pm-fav--ficha');
    zona.appendChild(b);
  }

  /* ---------------------------------------------------------------------
     3. El contador de la cabecera
     --------------------------------------------------------------------- */
  /* El contador se QUITA del DOM cuando está en cero, en vez de esconderse
     con el atributo hidden. Craft trae reglas de display para los <span> de
     dentro de .header__icon, y cualquier display declarado le gana al
     display:none que el navegador aplica a [hidden]: el resultado era una
     mancha negra junto al corazón con la lista vacía. Quitarlo del árbol no
     depende de qué hoja gane la cascada. */
  function pintarContador() {
    var n = leer().length;
    document.querySelectorAll('[data-pm-fav-enlace]').forEach(function (enlace) {
      var el = enlace.querySelector('[data-pm-fav-contador]');
      if (n > 0) {
        if (!el) {
          el = document.createElement('span');
          el.className = 'pm-fav-enlace__n';
          el.setAttribute('data-pm-fav-contador', '');
          enlace.appendChild(el);
        }
        el.textContent = String(n);
      } else if (el) {
        el.remove();
      }
    });
    document.querySelectorAll('[data-pm-fav-enlace]').forEach(function (el) {
      el.setAttribute('aria-label', n === 1 ? 'Favoritos, 1 pieza' : 'Favoritos, ' + n + ' piezas');
    });
  }

  function montarEnlaceCabecera() {
    var iconos = document.querySelector('.header__icons');
    if (!iconos || iconos.querySelector('[data-pm-fav-enlace]')) return;
    var a = document.createElement('a');
    a.href = window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') + '/pages/favoritos' : '/pages/favoritos';
    a.className = 'header__icon pm-fav-enlace link focus-inset';
    a.setAttribute('data-pm-fav-enlace', '');
    a.innerHTML = CORAZON;   // el contador lo añade pintarContador(), solo si hay piezas
    var carrito = iconos.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (carrito) iconos.insertBefore(a, carrito); else iconos.appendChild(a);
  }

  /* ---------------------------------------------------------------------
     4. La página de favoritos
     Pide a Shopify el JSON de cada pieza guardada. Si una ya no existe o se
     despublicó, se cae sola de la lista en vez de dejar un hueco roto.
     --------------------------------------------------------------------- */
  /* Un titulo con & o < rompia el HTML al entrar crudo por innerHTML. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function pesos(centavos) {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency', currency: 'COP', maximumFractionDigits: 0
      }).format(centavos / 100);
    } catch (e) { return '$' + Math.round(centavos / 100); }
  }

  function pintarPagina() {
    var zona = document.getElementById('pm-favoritos');
    if (!zona) return;

    var handles = leer();
    var vacio = document.getElementById('pm-favoritos-vacio');

    if (!handles.length) {
      zona.innerHTML = '';
      if (vacio) vacio.hidden = false;
      return;
    }
    if (vacio) vacio.hidden = true;
    zona.setAttribute('aria-busy', 'true');

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (productos) {
      var vivos = [];
      var html = '';

      productos.forEach(function (p, i) {
        if (!p) return;
        vivos.push(handles[i]);
        var img = p.featured_image
          ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_800x800_crop_center$1$2')
          : '';
        html +=
          '<li class="pm-fav-item">' +
            '<a class="pm-fav-item__foto" href="/products/' + esc(p.handle) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="800" height="800">' : '') +
            '</a>' +
            '<div class="pm-fav-item__pie">' +
              '<a class="pm-fav-item__nombre" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
              '<span class="pm-fav-item__precio">' + pesos(p.price) + '</span>' +
              '<button type="button" class="pm-fav-item__quitar" data-pm-fav-quitar="' + esc(p.handle) + '" aria-label="Quitar ' + esc(p.title) + ' de favoritos">Quitar</button>' +
            '</div>' +
          '</li>';
      });

      // Las que ya no existen se depuran en silencio.
      if (vivos.length !== handles.length) { guardar(vivos); pintarContador(); }

      zona.innerHTML = html;
      zona.removeAttribute('aria-busy');
      if (!vivos.length && vacio) vacio.hidden = false;

      zona.querySelectorAll('[data-pm-fav-quitar]').forEach(function (b) {
        b.addEventListener('click', function () {
          alternar(b.getAttribute('data-pm-fav-quitar'));
          pintarPagina();
        });
      });
    });
  }

  function iniciar() {
    montarEnTarjetas(document);
    montarEnFicha();
    montarEnlaceCabecera();
    pintarContador();
    pintarPagina();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // Craft repinta la rejilla al filtrar y al paginar, y el editor de temas
  // reinyecta secciones enteras: hay que volver a poner los corazones.
  document.addEventListener('shopify:section:load', function (e) {
    montarEnTarjetas(e.target); montarEnFicha(); pintarPagina();
  });
  document.addEventListener('pm:favoritos', function () {
    document.querySelectorAll('.pm-fav').forEach(function (b) {
      b.setAttribute('aria-pressed', tiene(b.dataset.pmFav) ? 'true' : 'false');
      refrescarBoton(b);
    });
  });
  new MutationObserver(function () { montarEnTarjetas(document); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
